/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, {useContext, useEffect, useState} from "react";

import {useDispatch} from "react-redux";
import {useTypedSelector} from "@Services/Hooks/UseTypedSelector";

import CHANGE_API_REQUEST_STATUS_ACTION from "@Actions/Interface/ChangeApiRequestStatus";
import CHANGE_API_REQUEST_TOKEN_ACTION from "@Actions/Api/ChangeApiRequestTokenValue";

import ApplicationApiContext from "@Contexts/Api";

import AUTHORIZATION_TOKEN_INTERFACE from "@Reducers/Api/RequestToken";
import LOGGED_USER_INTERFACE from "@Store/Interfaces/Authentication/User";

import REST_API_REQUEST from "@Services/Utilities/Requests";
import prepareRestApiRequestToken from "@Services/Utilities/RequestToken/Prepare";

type SessionExtendComponentProps = { SESSIONMAXTIMESECONDS: number; };

export const SessionExtendComponent: React.FC<SessionExtendComponentProps> = ({
    SESSIONMAXTIMESECONDS
}): JSX.Element | null => {

    /** @const Global State Actions Dispatcher */
    const DISPATCHER = useDispatch();


    const LOGGED_USER: LOGGED_USER_INTERFACE = useTypedSelector(
        (state):ReturnType<any> => state?.authentication
    )?.loggedUser || null;


    /** @const {string} Global Rest Api Root URL Address */
    const REST_API_URL = useContext(ApplicationApiContext)?.API_ROOT_URL || null;


    /** @const {object} REST_API_DATA - Application State Store Rest Api Data */
    const REST_API_DATA:ReturnType<any> = useTypedSelector(
        (state) => state.api
    );

    /** @const {} REST_API_REQUEST_TOKEN - Application Rest Api Request Token */
    const REST_API_REQUEST_TOKEN: AUTHORIZATION_TOKEN_INTERFACE = REST_API_DATA?.requestToken || null;

    const [sessionStart, setSessionStart] = useState(new Date());

    useEffect(() => {
        let myInterval = setInterval(() => {            
            if(REST_API_REQUEST_TOKEN.tokenValidTime && REST_API_REQUEST_TOKEN.tokenCreateDate) {
                let secoundsToTokenExpired : number = REST_API_REQUEST_TOKEN.tokenValidTime - ((new Date()).getTime() - +REST_API_REQUEST_TOKEN.tokenCreateDate)/1000;
                let sessionTimeSeconds : number = ((new Date()).getTime() - sessionStart.getTime())/1000;
                if(secoundsToTokenExpired < 70 && sessionTimeSeconds < SESSIONMAXTIMESECONDS){
                    REFRESH_TOKEN_REQUEST_HANDLER();
                }
            }
        }, 5000)
        return () => {
            clearInterval(myInterval);
        };
    });


    const REFRESH_TOKEN_REQUEST_HANDLER = async () => {

        DISPATCHER(CHANGE_API_REQUEST_STATUS_ACTION(true));

        const REFRESH_TOKEN_API_URL = `${REST_API_URL}/App/RefreshToken`;

        const REFRESH_TOKEN_REQUEST_DATA = {UserId: LOGGED_USER.userID};

        try {

            const REFRESH_TOKEN_RESPONSE = await REST_API_REQUEST(
                REFRESH_TOKEN_API_URL,
                REFRESH_TOKEN_REQUEST_DATA,
                REST_API_REQUEST_TOKEN
            );

            if (REFRESH_TOKEN_RESPONSE.status === 204) {
                DISPATCHER(CHANGE_API_REQUEST_TOKEN_ACTION(
                    prepareRestApiRequestToken(REFRESH_TOKEN_RESPONSE.headers)
                ));
            } 

        } catch (e) {
            
        }

        DISPATCHER(CHANGE_API_REQUEST_STATUS_ACTION(false));

    };

    return null;
};


export default SessionExtendComponent;
